import React from 'react';
import { Row } from '@src/components/Utils';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { SelectableButton } from '@src/components/SelectableButton';
import { XclusionSelection, XclusionManager } from '@src/types/Filters';
import { style } from 'typestyle';

interface Props {
  selected: XclusionSelection
  onChange: XclusionManager['onXclusionSwitch']
}

export function XclusionSwitch({ selected, onChange }: Props) {
  function renderButton(
    selection: XclusionSelection,
    isSelected: boolean,
    onChangeFn: (s: XclusionSelection) => void,
  ) {
    return (
      <SelectableButton
        key={selection}
        buttonStyle={{ size: 12 }}
        selected={isSelected}
        onClick={() => onChangeFn(selection)}
      >
        {lang[selection].toUpperCase()}
      </SelectableButton>
    );
  }

  return (
    <div>
      <Row className={switchClass}>
        {renderButton('inclusion', selected === 'inclusion', onChange)}
        <span>
          {lang.or}
        </span>
        {renderButton('exclusion', selected === 'exclusion', onChange)}
      </Row>
    </div>
  );
}

const lang = LocalizedStrings({
  en: {
    inclusion: 'Inclusion',
    exclusion: 'Exclusion',
    or: 'OR',
  },
});

const switchClass = style({
  width: '85%',
  justifyContent: 'space-between',
  marginBottom: 13,
});
